import {
  FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNSEARCH_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION,
  FETCH_EXPIRYRETURNVIEW_INIT_ACTION,
  FILTER_BY_EXPIRYRETURN_STATUS_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_EXPIRYRETURNDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        ExpiryReturnDtlsList: action.payload.rows,
        ExpiryReturnlsCount: action.payload.count
      };

    case FETCH_EXPIRYRETURNSEARCH_SUCCESS_ACTION:
      return {
        ...state,
        ExpiryReturnSearchList: action.payload.rows,
        ExpiryReturnSearchCount: action.payload.count
      };

    case FILTER_BY_EXPIRYRETURN_STATUS_SUCCESS_ACTION:
      return {
        ...state,
        expiryUserFilterList: action.payload.rows,
        expiryUserFilterCount: action.payload.count
      };

    case FETCH_EXPIRYRETURNVIEW_SUCCESS_ACTION:
      return {
        ...state,
        ExpiryReturnls: action.payload.rows,
        ExpiryReturnDtlsCount: action.payload.count
      };

    case FETCH_EXPIRYRETURNVIEW_INIT_ACTION:
      return {
        ...state,
        ExpiryReturnDtls: {}
      };

    default:
      return state;
  }
}
